export default __webpack_public_path__ + "static/media/zahran.efd58451.jpg";